// extracted by mini-css-extract-plugin
export var dropdownButton = "_13-0";
export var fullWidthDropdownButton = "_13-1";
export var icon = "_13-3";
export var iconPlaceholder = "_13-2";
export var menuItemRow = "_13-5";
export var shortcutContainer = "_13-4";